import { useState } from 'react';

import {
  ACCOUNT_USER_DETAIL_TAG_HISTORY_LIST_FILTER_OPTION_MODEL,
  ACCOUNT_USER_DETAIL_TAG_HISTORY_LIST_SORT_OPTION_MODEL,
} from './models';
import toastMsg from '../../../../../lib/toastMsg';
import accountUserToastMsg from '../../../../../constants/service/toastMsg/accountUserToastMsg';
import { useAccountUserDetailTagListQuery } from './query';

export const useAccountUserDetailTagList = ({ userId, isActive }) => {
  const [sortOption, setSortOption] = useState(ACCOUNT_USER_DETAIL_TAG_HISTORY_LIST_SORT_OPTION_MODEL);
  const [filterOption, setFilterOption] = useState(ACCOUNT_USER_DETAIL_TAG_HISTORY_LIST_FILTER_OPTION_MODEL);
  const { data } = useAccountUserDetailTagListQuery({
    userId,
    sortOption,
    filterOption,
    options: {
      enabled: !!userId && isActive,
      onSuccess: () => toastMsg.success(accountUserToastMsg.GET_USER_DETAIL_TAG_LIST_REQUEST_SUCCESS),
      onError: (error) => {
        toastMsg.error(error.message);
      },
      select: (result) => ({
        list: result.data.tagHistoryList.list,
        totalCnt: result.data.tagHistoryList.totalCnt,
      }),
    },
  });

  const getList = ({ filterOption, sortOption }) => {
    filterOption && setFilterOption(filterOption);
    sortOption && setSortOption(sortOption);
  };

  return {
    tagHistory: data,
    getList,
    sortOption,
    filterOption,
  };
};
